import React from "react";

export default class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const selection = {
      valueId: event.currentTarget[event.currentTarget.selectedIndex].value,
      nummer: event.currentTarget[
        event.currentTarget.selectedIndex
      ].getAttribute("nummer"),
      id: event.currentTarget[event.currentTarget.selectedIndex].getAttribute(
        "id"
      )
    };
    this.props.onChildChange(this.props.configuration.index, selection);
  }

  render() {
    let values = this.props.configuration.values;
    return (
      <div
        key={this.props.configuration.order}
        className={this.props.isHidden ? "hidden" : ""}
      >
        <label htmlFor={this.props.configuration.order}>
          {this.props.configuration.label}
        </label>
        <select
          onChange={this.handleChange}
          disabled={this.props.disabled}
          value={this.props.value}
          id={this.props.configuration.id}
        >
          <option value="">Bitte auswählen</option>
          {values &&
            values.map(item => (
              <option
                key={this.props.configuration.label + item.id}
                nummer={item.nummer}
                value={item.id}
                id={this.props.configuration.id}
              >
                {item.nicename}
              </option>
            ))}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/Dropdown.js